export var DatasourceAction = /*#__PURE__*/function (DatasourceAction) {
  DatasourceAction["COLUMN_ADDED"] = "column added";
  DatasourceAction["COLUMN_REMOVED"] = "column removed";
  DatasourceAction["COLUMN_REORDERED"] = "column reordered";
  DatasourceAction["INSTANCE_UPDATED"] = "instance updated";
  DatasourceAction["QUERY_UPDATED"] = "query updated";
  DatasourceAction["DISPLAY_VIEW_CHANGED"] = "display view changed";
  DatasourceAction["NEXT_PAGE_SCROLLED"] = "next page scrolled";
  DatasourceAction["SCHEMA_UPDATED"] = "schema updated";
  return DatasourceAction;
}({});
export var DatasourceDisplay = /*#__PURE__*/function (DatasourceDisplay) {
  DatasourceDisplay["DATASOURCE_TABLE"] = "datasource_table";
  DatasourceDisplay["DATASOURCE_INLINE"] = "datasource_inline";
  DatasourceDisplay["INLINE"] = "inline";
  return DatasourceDisplay;
}({});
export var DatasourceSearchMethod = /*#__PURE__*/function (DatasourceSearchMethod) {
  DatasourceSearchMethod["DATASOURCE_BASIC_FILTER"] = "datasource_basic_filter";
  DatasourceSearchMethod["DATASOURCE_SEARCH_QUERY"] = "datasource_search_query";
  return DatasourceSearchMethod;
}({});